// Actions
import { rememberPassActions, rememberPassActionTypes } from './rememberPass.actions';

import { RememberPassState } from './rememberPass.state';

const defaultState: RememberPassState = {
    error: 0,
    ok: false,
    result: {},
};

export type Action = rememberPassActions;

export function RememberPassReducer(state = defaultState, action: any) {
    switch (action.type) {
        case rememberPassActionTypes.DO_REMEMBER:
            return {
                ...state,
                result: {},
            };
        case rememberPassActionTypes.DO_REMEMBER_SUCCESS:
            return {
                ...state,
                ok: true,
                error: 0,
                result: action.payload,
            };
        case rememberPassActionTypes.DO_REMEMBER_FAIL:
            return {
                ...state,
                ok: false,
                error: action.error,
                result: action.payload,
            };
        default:
            return state;
    }
}
